var Agitavit;
(function (Agitavit) {
    var Controls;
    (function (Controls) {
        /**
         * Base class for UI controls.
         */
        var AgControlBase = /** @class */ (function () {
            /**
             * Creates new instance of control base.
             * @param rootElement - The root element which will be replaced with this control.
             * @param data - The control data.
             * @param state - The control state.
             * @param name - The name of the control (for postback purposes).
             * @param isInlineGrid - The check if element is in grid
             */
            function AgControlBase(rootElement, data, state, name, isInlineGrid, inlineOptions) {
                this.onChangeEvent = new Agitavit.EventDispatcher();
                this.onInputEvent = new Agitavit.EventDispatcher();
                this.onBlurEvent = new Agitavit.EventDispatcher();
                this.onFocusEvent = new Agitavit.EventDispatcher();
                this.data = data;
                this.state = state;
                this.name = name;
                this.testid = name && name.startsWith("DynamicData.") ? name.substring("DynamicData.".length) : name;
                this.isInlineGrid = isInlineGrid;
                this.inlineOptions = inlineOptions;
                // set defaults
                if (!data) {
                    this.data = {};
                }
                if (!state) {
                    this.state = {
                        IsRequired: false,
                        IsDisabled: false,
                        IsReadonly: false
                    };
                }
                if (!name) {
                    this.name = Agitavit.Utilities.getUniqueId();
                }
                // create element placeholder
                var element = document.createElement("div");
                rootElement.appendChild(element);
                this.rootElement = element;
                // set initial validation (display required information)
                this.resetParentValidation();
            }
            /**
             * Sets control value to new value.
             * @param value - New control value.
             * @param triggerOnChange - Indicates whether on change event should be fired.
             * @param skipRender - Indicates whether re-rendering should be skipped.
             */
            AgControlBase.prototype.setValue = function (value, triggerOnChange, skipRender) {
                this.data = Object.assign({}, this.data);
                this.data.Value = value;
                if (!skipRender) {
                    this.render();
                }
                // on input event is always called
                this.onInputEvent.dispatch(this, value);
                if (triggerOnChange) {
                    this.onChangeEvent.dispatch(this, value);
                }
            };
            /**
             * Gets control value.
             */
            AgControlBase.prototype.getValue = function () {
                return this.data.Value;
            };
            /**
             * Updates control data with given values. Only provided values are used, undefined values are ignored.
             * @param data - New control data to be merged with existing data.
             */
            AgControlBase.prototype.setData = function (data, skipRender) {
                var _this = this;
                this.data = Object.assign({}, this.data);
                Object.keys(data).forEach(function (key) {
                    if (data[key] !== undefined) {
                        _this.data[key] = data[key];
                    }
                });
                // on input event is always called
                this.onInputEvent.dispatch(this, this.data.Value);
                if (!skipRender) {
                    this.render();
                }
            };
            /**
             * Gets control data.
             */
            AgControlBase.prototype.getData = function () {
                return this.data;
            };
            /**
             * Hides the control.
             */
            AgControlBase.prototype.hide = function () {
                // hide control
                var el = this.rootElement.closest(".ag-form-element");
                el.classList.add("ag-hidden");
                // hide the row if all inner elements are hidden
                var row = el.parentElement.parentElement;
                if (row.classList.contains("row") && row.querySelectorAll(".ag-form-element:not(.ag-hidden)").length === 0) {
                    row.classList.add("ag-hidden");
                }
            };
            /**
             * Shows the control.
             */
            AgControlBase.prototype.show = function () {
                // show control
                var el = this.rootElement.closest(".ag-form-element");
                el.classList.remove("ag-hidden");
                // show the row
                var row = el.parentElement.parentElement;
                if (row.classList.contains("row")) {
                    row.classList.remove("ag-hidden");
                }
            };
            /**
             * Gets value(s) required for postback.
             */
            AgControlBase.prototype.getPostBackValue = function () {
                return this.getValue();
            };
            /**
             * Sets a value indicating whether control is required.
             * @param required - Value indicating whether control is required.
             */
            AgControlBase.prototype.setRequired = function (required) {
                if (this.state.IsRequired === required) {
                    return;
                }
                this.state.IsRequired = required;
                this.resetParentValidation();
                this.render();
            };
            /**
             * Gets value indicating whether control is required.
             */
            AgControlBase.prototype.getRequired = function () {
                return this.state.IsRequired;
            };
            /**
             * Sets a value indicating whether control is disabled.
             * @param disabled - Value indicating whether control is disabled.
             */
            AgControlBase.prototype.setDisabled = function (disabled) {
                if (this.state.IsDisabled === disabled) {
                    return;
                }
                this.state.IsDisabled = disabled;
                this.resetParentValidation();
                this.render();
            };
            /**
             * Gets a value indicating whether control is disabled.
             */
            AgControlBase.prototype.getDisabled = function () {
                return this.state.IsDisabled;
            };
            /**
             * Sets a value indicating whether control is readonly.
             * @param readonly - Value indicating whether controls is readonly.
             */
            AgControlBase.prototype.setReadonly = function (readonly) {
                if (this.state.IsReadonly === readonly) {
                    return;
                }
                this.state.IsReadonly = readonly;
                this.resetParentValidation();
                this.render();
            };
            /**
             * Gets a value indicating whether control is readonly.
             */
            AgControlBase.prototype.getReadonly = function () {
                return this.state.IsReadonly;
            };
            Object.defineProperty(AgControlBase.prototype, "onChange", {
                /**
                 * On change event. Fired after value of the control is changed.
                 * @returns {}
                 */
                get: function () {
                    return this.onChangeEvent.asEvent();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(AgControlBase.prototype, "onBlur", {
                /**
                 * On blur event. Fired after control has lost focus
                 * @returns {}
                 */
                get: function () {
                    return this.onBlurEvent.asEvent();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(AgControlBase.prototype, "onFocus", {
                /**
                 * On focus event. Fired after control has set focus
                 * @returns {}
                 */
                get: function () {
                    return this.onFocusEvent.asEvent();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(AgControlBase.prototype, "onInput", {
                /**
                 * On input event. Fired everytime value or data of the control is changed.
                 * @returns {}
                 */
                get: function () {
                    return this.onInputEvent.asEvent();
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Clear all event of control instance.
             */
            AgControlBase.prototype.clearEvents = function () {
                this.onBlurEvent.clear();
                this.onChangeEvent.clear();
                this.onFocusEvent.clear();
            };
            /**
             * Generates form element data request with information required by this control.
             */
            AgControlBase.prototype.getFormElementDataRequest = function () {
                var name = this.name;
                if (name.startsWith("DynamicData.")) {
                    name = name.replace("DynamicData.", "");
                }
                return {
                    ElementBaseName: name
                };
            };
            AgControlBase.prototype.replaceRootElement = function (newElement) {
                // remove validation rules
                Controls.Utilities.removeValidationRules(this.rootElement);
                // replace element
                this.rootElement.parentElement.replaceChild(newElement, this.rootElement);
                this.rootElement = newElement;
            };
            AgControlBase.prototype.resetParentValidation = function () {
                // toggle validation classes on parent
                var $validationNode = $(this.rootElement).closest(".validation-node");
                $validationNode.toggleClass("required", this.state.IsRequired && !this.state.IsReadonly && !this.state.IsDisabled);
                $validationNode.removeClass("has-error has-feedback").find("span.form-control-feedback").hide();
            };
            return AgControlBase;
        }());
        Controls.AgControlBase = AgControlBase;
    })(Controls = Agitavit.Controls || (Agitavit.Controls = {}));
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=AgControlBase.js.map